export const RequestDocumentConfig = {
  type: "fieldRecursive",
  title: "fieldRecursive",
  name: "fieldRecursive",
  show: true,
  custom_styles: "classname_1",
  input_fields: [
    {
      type: "inputGroup",
      id: "support_doc_name",
      label: "Enter Supporting Document Name",
      req_type: "upload",
      name: "support_doc_name",
      size: "col-lg-12 col-md-12 col-sm-12",
      placeholder: "Eg: Pan card",
      validators: {
        required: false,
        pattern: [],
        min_length: "",
        max_length: "",
      },
    },
  ],
};


